import React, {useEffect, useRef, useState} from "react";
import {Check, KeyboardArrowDown, Language} from "@mui/icons-material";
import {getLocale, setLocale, SUPPORTED_LOCALES} from "~/i18n/i18n.ts";

const LANG_NAMES: Record<string, string> = {'en': 'English', 'pt-BR': 'Português'};
const LANG_CODES: Record<string, string> = {'en': 'EN', 'pt-BR': 'PT'};

/** Header language switcher (Mithra 3.0 `.sit-lang`): a compact code pill with a
 * dropdown of the supported locales. `setLocale` persists + reloads. Hidden entirely
 * when a tenant only has one locale (`en`) to pick from. */
export const SitLanguageSwitch: React.FC = () => {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!open) return;
        const onDown = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
        };
        document.addEventListener('mousedown', onDown);
        return () => document.removeEventListener('mousedown', onDown);
    }, [open]);

    if (SUPPORTED_LOCALES.length < 2) return null;

    const cur = getLocale();
    return (
        <div className="sit-lang" ref={ref}>
            <button type="button" className={'sit-lang-btn' + (open ? ' open' : '')}
                    title="Language" onClick={() => setOpen(o => !o)}>
                <span className="sit-lang-flag"><Language fontSize="small"/></span>
                <span className="sit-lang-code">{LANG_CODES[cur] ?? cur}</span>
                <KeyboardArrowDown fontSize="small"/>
            </button>
            {open && <div className="sit-lang-menu">
                {SUPPORTED_LOCALES.map((loc) => (
                    <button type="button" key={loc} className={'sit-lang-item' + (loc === cur ? ' on' : '')}
                            onClick={() => setLocale(loc)}>
                        <span>{LANG_NAMES[loc] ?? loc}</span>
                        {loc === cur && <Check fontSize="small"/>}
                    </button>
                ))}
            </div>}
        </div>
    );
};
